import { getMediaQueryList } from '../getMediaQueryList/getMediaQueryList';
import { Breakpoints } from '../../components/Experimenter/types';

export const isMobileLayout = (screenMaxWidth: Breakpoints = Breakpoints.MD) => {
  const mediaList = getMediaQueryList(screenMaxWidth);

  if (mediaList) {
    return mediaList.matches;
  }

  return false;
};
